export enum OrderFulfillmentTypeEnum {
  DineIn = 'DineIn',
  TakeAway = 'TakeAway',
  Delivery = 'Delivery',
}
